"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setUserBackground", {
  enumerable: true,
  get: function get() {
    return _setUserBackground["default"];
  }
});
var _setUserBackground = _interopRequireDefault(require("./setUserBackground"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }